import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const JustifyFormatIcon = (props)=>{
    const $ = c(5);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M15.5 1.25C15.5 0.835786 15.1585 0.5 14.7561 0.5H1.24385C0.833034 0.5 0.5 0.832899 0.5 1.25C0.5 1.66421 0.841479 2 1.24385 2H14.7561C15.167 2 15.5 1.6671 15.5 1.25ZM15.5 11.25C15.5 10.8358 15.1585 10.5 14.7561 10.5H1.24385C0.833034 10.5 0.5 10.8329 0.5 11.25C0.5 11.6642 0.841479 12 1.24385 12H14.7561C15.167 12 15.5 11.6671 15.5 11.25Z",
            fill: "currentColor"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M14.7562 5.5C15.1586 5.5 15.5001 5.83579 15.5001 6.25C15.5001 6.6671 15.167 7 14.7562 7H1.24393C0.841557 7 0.500078 6.66421 0.500078 6.25C0.500078 5.8329 0.833112 5.5 1.24393 5.5H14.7562Z",
            fill: "currentColor"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] !== props.height || $[3] !== props.width) {
        t2 = /*#__PURE__*/ jsxs("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 16 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1
            ]
        });
        $[2] = props.height;
        $[3] = props.width;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
export { JustifyFormatIcon };
